module.exports = __webpack_public_path__ + "img/Logo Mascot CS4_primate fire.jpg";